import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetPartnersListQuery } from '../../redux/api/common';
import PartnerItem from '../partnerItem';

export default function PartnersSlider({ className = '' }) {
  const { t } = useTranslation('common');

  const { data: partnersList = [] } = useGetPartnersListQuery();
  const [hasSlider, setHasSlider] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setHasSliderByWidth();
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [partnersList]);

  const partnerCardWidth = 235;

  const setHasSliderByWidth = useCallback(() => {
    setHasSlider(window.innerWidth / partnerCardWidth < partnersList.length)
  }, [partnersList]);

  const partners = useMemo(() => {
    const items = hasSlider ? [...partnersList, ...partnersList] : partnersList;
    return items.map((item, index) => (
      <PartnerItem key={item.id + `${index}`} partnerData={item} linkActive={false}
                   className={' border rounded-lg overflow-hidden opacity-50 hover:opacity-100'}
                   classNamesImg={`w-[${partnerCardWidth}px] h-[98px] py-8 px-10 border rounded-lg flex items-center justify-center`} />
    ));
  }, [partnersList, partnerCardWidth, hasSlider]);

  return !partnersList.length ? null : (
    <div className={`flex items-center flex-col w-full ${className}`}>
        <div className="mb-4 text-base font-normal tracking-tight leading-[1.16] text-black/70">
          <span>{t('titles.partners')}</span>
        </div>
      <div className="overflow-hidden w-full bg-white">
        <div
          className={`flex gap-4 items-center justify-center ${hasSlider ? 'w-max animate-slideLeft' : 'animate-none w-full'}`}
          style={{ animationDuration: `${10 * (partners.length / 20)}s` }}>
          {partners}
        </div>
      </div>
    </div>
  );
}
